import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyPages.css';

import luminaLogo from '../assets/luminalogo3.png';

const TermsPage = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-page">
            <div className="policy-container">
                <div className="policy-header">
                    <img src={luminaLogo} alt="Lumina Logo" className="policy-logo" />
                    <div className="policy-divider" />
                    <h1 className="policy-title">Allgemeine Geschäftsbedingungen</h1>
                </div>

                <div className="policy-content">
                    <section>
                        <h2>ÜBERSICHT</h2>
                        <p>
                            Diese Website wird von LuminaQR betrieben. Überall auf der Webseite beziehen sich die Begriffe "wir", "uns" und "unsere/e" auf LuminaQR.
                            LuminaQR bietet diese Website, einschließlich aller Informationen, Tools und Dienste, die auf dieser Website verfügbar sind, Ihnen, dem Benutzer,
                            unter der Bedingung an, dass Sie alle hier angegebenen Bedingungen, Konditionen, Richtlinien und Hinweise akzeptieren.
                        </p>
                        <p>
                            Wenn Sie unsere Website besuchen und/oder etwas bei uns kaufen, nutzen Sie unseren "Dienst" und erklären sich damit einverstanden,
                            an die folgenden Allgemeinen Geschäftsbedingungen ("Allgemeine Geschäftsbedingungen", "Bedingungen") gebunden zu sein,
                            einschließlich der zusätzlichen Geschäftsbedingungen und Richtlinien, die hierin erwähnt werden und/oder per Hyperlink verfügbar sind.
                            Diese Allgemeinen Geschäftsbedingungen gelten für alle Benutzer der Website, insbesondere Benutzer, die Besucher, Anbieter, Kunden,
                            Händler und/oder Verfasser von Inhalten sind.
                        </p>
                        <p>
                            Bitte lesen Sie diese Allgemeinen Geschäftsbedingungen sorgfältig durch, bevor Sie auf unsere Website zugreifen oder diese benutzen.
                            Durch den Zugriff auf oder die Nutzung eines jeglichen Teils der Website erklären Sie sich mit diesen Allgemeinen Geschäftsbedingungen einverstanden.
                            Sind Sie nicht mit allen Geschäftsbedingungen dieser Vereinbarung einverstanden, dürfen Sie nicht auf die Website zugreifen oder irgendwelche Dienste nutzen.
                        </p>
                        <p>
                            Alle neuen Funktionen oder Tools, die zum aktuellen Shop hinzugefügt werden, unterliegen ebenfalls den Allgemeinen Geschäftsbedingungen.
                            Sie können die aktuellste Version der Allgemeinen Geschäftsbedingungen jederzeit auf dieser Seite einsehen. Wir behalten uns das Recht vor,
                            Teile dieser Allgemeinen Geschäftsbedingungen durch Veröffentlichung von Updates und/oder Änderungen unserer Website zu aktualisieren,
                            zu ändern oder zu ersetzen. Es liegt in Ihrer Verantwortung, diese Seite regelmäßig auf mögliche Änderungen zu überprüfen.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 1 - BEDINGUNGEN FÜR DEN ONLINESHOP</h2>
                        <p>
                            Mit der Zustimmung zu diesen Allgemeinen Geschäftsbedingungen erklären Sie, dass Sie in dem Land Ihres Wohnsitzes mindestens volljährig sind
                            oder dass Sie in dem Land Ihres Wohnsitz volljährig sind und uns Ihre Zustimmung gegeben haben, dass Ihre minderjährigen Angehörigen
                            diese Website nutzen dürfen.
                        </p>
                        <p>
                            Sie dürfen unsere Produkte weder für illegale oder nicht autorisierte Zwecke nutzen noch dürfen Sie durch die Nutzung der Serviceleistung
                            gegen Gesetze in Ihrer Gerichtsbarkeit verstoßen (einschließlich, aber nicht beschränkt auf Urheberrechtsgesetze).
                        </p>
                        <p>
                            Sie dürfen keine Würmer oder Viren oder sonstigen Code destruktiver Art übertragen.
                        </p>
                        <p>
                            Der Verstoß gegen oder die Verletzung irgendeiner dieser Bedingungen führt zur sofortigen Kündigung Ihrer Serviceleistungen.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 2 - ALLGEMEINE BEDINGUNGEN</h2>
                        <p>
                            Wir behalten uns das Recht vor, einer Person die Serviceleistung jederzeit aus beliebigem Grund zu verweigern.
                        </p>
                        <p>
                            Sie nehmen zur Kenntnis, dass Ihre Informationen (außer Kreditkarteninformationen) unverschlüsselt übertragen werden können und
                            (a) Übertragungen über verschiedene Netzwerke sowie (b) Änderungen beinhalten können, um den technischen Anforderungen von verbundenen
                            Netzwerken oder Geräten zu entsprechen und sich an diese anzupassen. Kreditkarteninformationen werden bei der Übertragung über Netzwerke
                            immer verschlüsselt.
                        </p>
                        <p>
                            Sie verpflichten sich, ohne ausdrückliche schriftliche Genehmigung von uns keinen Teil der Serviceleistung, die Nutzung der Serviceleistung
                            oder den Zugriff auf die Serviceleistung oder auf jegliche Kontakte auf der Website, durch die die Serviceleistung angeboten wird,
                            zu reproduzieren, zu vervielfältigen, zu kopieren, zu verkaufen, weiterzuverkaufen oder zu verwerten.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 3 - GENAUIGKEIT, VOLLSTÄNDIGKEIT UND RECHTZEITIGKEIT DER INFORMATIONEN</h2>
                        <p>
                            Wir sind nicht verantwortlich, wenn die auf dieser Seite zur Verfügung gestellten Informationen nicht genau, vollständig oder aktuell sind.
                            Das Material auf dieser Website dient nur der allgemeinen Information und sollte nicht als alleinige Grundlage für Entscheidungen herangezogen werden,
                            ohne primäre, genauere, vollständigere oder aktuellere Informationsquellen zu prüfen. Jegliches Vertrauen auf das Material auf dieser Website
                            geschieht auf eigene Verantwortung.
                        </p>
                        <p>
                            Diese Seite enthält möglicherweise gewisse historische Informationen. Historische Informationen sind nicht unbedingt aktuell und werden lediglich
                            zu Ihrer Orientierung bereitgestellt. Wir behalten uns das Recht vor, Inhalte auf dieser Website jederzeit zu ändern, sind aber nicht verpflichtet,
                            irgendwelche Informationen auf unserer Website zu aktualisieren.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 4 - ÄNDERUNGEN AN DER LEISTUNG UND DEN PREISEN</h2>
                        <p>
                            Die Preise für unsere Produkte können ohne vorherige Ankündigung geändert werden.
                        </p>
                        <p>
                            Wir behalten uns das Recht vor, die Serviceleistung (oder einen jeglichen Teil oder Inhalt davon) ohne Ankündigung jederzeit zu ändern oder zu beenden.
                        </p>
                        <p>
                            Wir sind weder Ihnen noch Dritten gegenüber haftbar für Änderungen, Preisänderungen, Sperrung oder Einstellung der Serviceleistung.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 5 - PRODUKTE ODER SERVICELEISTUNGEN</h2>
                        <p>
                            Gewisse Produkte oder Serviceleistungen sind möglicherweise nur online über die Website erhältlich. Diese Produkte oder Serviceleistungen
                            sind unter Umständen nur in begrenzten Mengen vorhanden und unterliegen nur der Rückgabe oder dem Umtausch gemäß unseren Rückgaberichtlinien.
                        </p>
                        <p>
                            Wir haben uns bemüht, die Farben und Bilder unserer Produkte, die im Shop erscheinen, so genau wie möglich darzustellen.
                            Wir können nicht garantieren, dass Ihr Computerbildschirm jede Farbe korrekt anzeigt.
                        </p>
                        <p>
                            Wir behalten uns das Recht vor, sind aber nicht verpflichtet, den Verkauf unserer Produkte oder Serviceleistungen auf gewisse Personen,
                            geografische Regionen oder Gerichtsbarkeiten zu beschränken. Wir können dieses Recht von Fall zu Fall ausüben.
                        </p>
                        <p>
                            Wir garantieren nicht, dass die Qualität von Produkten, Serviceleistungen, Informationen oder anderen Materialien, die von Ihnen gekauft oder
                            erworben wurden, Ihren Erwartungen entspricht, oder dass Fehler in der Serviceleistung korrigiert werden.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 6 - RICHTIGKEIT DER RECHNUNGS- UND KONTOINFORMATIONEN</h2>
                        <p>
                            Wir behalten uns das Recht vor, jegliche Bestellung, die Sie bei uns aufgeben, abzulehnen. Wir können nach eigenem Ermessen die Abnahmemengen
                            pro Person, pro Haushalt oder pro Bestellung begrenzen oder stornieren.
                        </p>
                        <p>
                            Sie verpflichten sich, beim Kauf auf unserer Website aktuelle, vollständige und genaue Kauf- und Kontoinformationen zur Verfügung zu stellen.
                            Sie verpflichten sich, Ihre Kontoinformationen, einschließlich Ihrer E-Mail-Adresse und Kreditkartennummern und Verfallsdaten, unverzüglich
                            zu aktualisieren, sodass wir Ihre Transaktionen abschließen und Sie bei Bedarf kontaktieren können.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 7 - VERBOTENE ANWENDUNGEN</h2>
                        <p>
                            Zusätzlich zu anderen Verboten, die in den Allgemeinen Geschäftsbedingungen dargelegt sind, ist es Ihnen untersagt,
                            die Website oder ihren Inhalt für Folgendes zu nutzen:
                        </p>
                        <ul>
                            <li>für rechtswidrige Zwecke</li>
                            <li>um andere zur Durchführung oder Teilnahme an ungesetzlichen Handlungen aufzufordern</li>
                            <li>um gegen internationale, bundesstaatliche, provinzielle oder staatliche Vorschriften, Regeln, Gesetze oder örtliche Verordnungen zu verstoßen</li>
                            <li>um unsere Rechte an geistigem Eigentum oder die Rechte an geistigem Eigentum anderer zu beeinträchtigen oder zu verletzen</li>
                            <li>um zu belästigen, zu missbrauchen, zu beleidigen, zu verletzen, zu diffamieren, zu verleumden, zu verunglimpfen, einzuschüchtern oder
                                aufgrund von Geschlecht, sexueller Orientierung, Religion, ethnischer Zugehörigkeit, Rasse, Alter, nationaler Herkunft oder Behinderung zu diskriminieren</li>
                            <li>falsche oder irreführende Informationen zu übermitteln</li>
                            <li>um Viren oder jede andere Art von schädlichem Code hochzuladen oder zu übertragen</li>
                            <li>um persönliche Daten anderer zu sammeln oder zu verfolgen</li>
                            <li>zum Spammen, Phishing, Pharming, Pretexting, Spidering, Crawling oder Scraping</li>
                            <li>für irgendwelche obszönen oder unmoralischen Zwecke</li>
                            <li>um die Sicherheitsfunktionen der Serviceleistung oder irgendeiner zugehörigen Website, anderer Websites oder des Internets zu stören oder zu umgehen</li>
                        </ul>
                        <p>
                            Wir behalten uns das Recht vor, Ihre Nutzung der Serviceleistung oder irgendeiner zugehörigen Website zu beenden,
                            wenn Sie eine der verbotenen Anwendungen missachten.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 8 - HAFTUNGSAUSSCHLUSS; HAFTUNGSBESCHRÄNKUNG</h2>
                        <p>
                            Wir übernehmen keine Garantie, Verantwortung oder Gewährleistung dafür, dass die Nutzung unserer Serviceleistung ununterbrochen,
                            zeitgerecht, sicher oder fehlerfrei erfolgt.
                        </p>
                        <p>
                            Wir garantieren nicht, dass die Ergebnisse, die durch die Nutzung der Serviceleistung erzielt werden können, genau oder zuverlässig sind.
                        </p>
                        <p>
                            Sie stimmen zu, dass wir von Zeit zu Zeit die Serviceleistung auf unbestimmte Zeit entfernen oder jederzeit ohne Benachrichtigung
                            an Sie einstellen können.
                        </p>
                        <p>
                            Der Service und alle Produkte und Serviceleistungen, die Ihnen über den Service angeboten werden, werden Ihnen
                            (sofern nicht ausdrücklich von uns angegeben) "wie besehen" und "wie verfügbar" zur Ihrer Nutzung bereitgestellt,
                            und zwar ohne jegliche Zusicherungen, Gewährleistungen oder Bedingungen jeglicher Art.
                        </p>
                        <p>
                            Auf keinen Fall sind LuminaQR, unsere Direktoren, leitenden Angestellten, Mitarbeiter, Tochtergesellschaften, Vertreter,
                            Auftragnehmer, Praktikanten, Lieferanten, Dienstanbieter oder Lizenzgeber haftbar für irgendwelche Verletzungen, Verluste,
                            Ansprüche oder jegliche direkte, indirekte, zufällige, strafende, besondere oder Folgeschäden jeglicher Art, einschließlich,
                            aber nicht beschränkt auf entgangene Gewinne, entgangene Einnahmen, verlorene Einsparungen, Datenverlust oder ähnliche Schäden.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 9 - ENTSCHÄDIGUNG</h2>
                        <p>
                            Sie verpflichten sich, LuminaQR und unsere Muttergesellschaft, Tochtergesellschaften, verbundenen Unternehmen, Partner,
                            leitenden Angestellten, Führungskräfte, Vertreter, Auftragnehmer, Lizenzgeber, Dienstleister, Subunternehmer, Lieferanten,
                            Praktikanten und Mitarbeiter im Zusammenhang mit Ansprüchen oder Forderungen, einschließlich angemessener Anwaltskosten,
                            die von Dritten aufgrund Ihrer Verletzung dieser Allgemeinen Geschäftsbedingungen oder der Dokumente, die durch Bezugnahme
                            darauf Bestandteil derselben sind, oder Ihrer Verletzung eines Gesetzes oder der Rechte eines Dritten geltend gemacht werden,
                            zu entschädigen, zu verteidigen und schadlos zu halten.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 10 - SALVATORISCHE KLAUSEL</h2>
                        <p>
                            Sollte sich herausstellen, dass eine Bestimmung dieser Allgemeinen Geschäftsbedingungen rechtswidrig, nichtig oder nicht
                            durchsetzbar ist, ist diese Bestimmung dennoch im gesetzlich zugelassenen Umfang durchsetzbar, und der nicht durchsetzbare
                            Teil gilt als von diesen Allgemeinen Geschäftsbedingungen getrennt, wobei eine solche Festlegung keine Auswirkungen auf
                            die Gültigkeit und Durchsetzbarkeit der übrigen Bestimmungen hat.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 11 - KÜNDIGUNG</h2>
                        <p>
                            Die Verpflichtungen und Verbindlichkeiten der Parteien, die vor dem Kündigungsdatum entstanden sind, überdauern die Kündigung
                            dieser Vereinbarung für alle Zwecke.
                        </p>
                        <p>
                            Diese Allgemeinen Geschäftsbedingungen sind so lange gültig, bis sie von Ihnen oder uns gekündigt werden. Sie können diese
                            Allgemeinen Geschäftsbedingungen jederzeit kündigen, indem Sie uns mitteilen, dass Sie unsere Dienste nicht mehr nutzen möchten,
                            oder wenn Sie die Nutzung unserer Website einstellen.
                        </p>
                        <p>
                            Wenn Sie es nach unserem alleinigen Ermessen versäumen, irgendeine Bestimmung dieser Allgemeinen Geschäftsbedingungen zu erfüllen,
                            oder wir dies vermuten, können wir diese Vereinbarung jederzeit fristlos kündigen, und Sie bleiben für alle fälligen Beträge bis
                            einschließlich Kündigungsdatum haftbar.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 12 - GESAMTE VEREINBARUNG</h2>
                        <p>
                            Das Versäumnis unsererseits, ein Recht oder eine Bestimmung dieser Allgemeinen Geschäftsbedingungen auszuüben oder durchzusetzen,
                            stellt keinen Verzicht auf dieses Recht oder diese Bestimmung dar.
                        </p>
                        <p>
                            Diese Allgemeinen Geschäftsbedingungen sowie von uns auf dieser Website oder in Bezug auf die Serviceleistung veröffentlichten
                            Richtlinien oder Betriebsvorschriften, stellen die gesamte Vereinbarung und Übereinkunft zwischen Ihnen und uns dar, regeln Ihre
                            Nutzung der Serviceleistung und ersetzen alle vorherigen oder gleichzeitigen Vereinbarungen, Mitteilungen und Angebote, mündlich
                            oder schriftlich, zwischen Ihnen und uns.
                        </p>
                    </section>

                    <section>
                        <h2>ABSCHNITT 13 - KONTAKTINFORMATIONEN</h2>
                        <p>
                            Fragen zu den Allgemeinen Geschäftsbedingungen sollten an uns gesendet werden unter:
                        </p>
                        <p className="contact-info">
                            LuminaQR<br />
                            Straubinger Straße 22a<br />
                            4600 Wels, Österreich<br />
                            E-Mail: contact@luminaqr.com<br />
                            Telefon: 06765019011
                        </p>
                    </section>

                    <div className="policy-footer-text">
                        <p>Stand: Februar 2025</p>
                    </div>
                </div>

                <div className="policy-actions">
                    <button className="back-btn" onClick={() => navigate(-1)}>
                        ← Zurück
                    </button>
                    <button className="home-btn" onClick={() => navigate('/')}>
                        Zur Startseite
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsPage;
